import { createSelector } from 'reselect'
import { get } from 'lodash'

import key from './types'
import { initialState } from './reducer'

const selectErrorLog = state => get(state, key, initialState)

const selectLoading = createSelector(
  selectErrorLog, state => get(state, 'loading', null)
)

const selectLoadingErrorLog = createSelector(
  selectErrorLog, state => get(state, 'errorLogLoading', null)
)

const selectSuccess = createSelector(
  selectErrorLog, state => get(state, 'errorLogList', [])
)

const selectColumns = createSelector(
  selectErrorLog, state => get(state, 'columns', [])
)

const selectPages = createSelector(
  selectErrorLog, state => get(state, 'pages', null)
)

const selectTotalItems = createSelector(
  selectErrorLog, state => get(state, 'totalItems', 0)
)

const selectError = createSelector(
  selectErrorLog, state => get(state, 'error', null)
)

const selectDataFilters = createSelector(
  selectErrorLog, state => get(state, 'dataFilters', [])
)

const selectDataFiltersError = createSelector(
  selectErrorLog, state => get(state, 'dataFiltersError', null)
)

export default {
  SUCCESS: selectSuccess,
  COLUMNS: selectColumns,
  ERROR: selectError,
  LOADING: selectLoading,
  LOADING_LIST: selectLoadingErrorLog,
  PAGES: selectPages,
  TOTAL_ITEMS: selectTotalItems,

  FILTER_OBJECT: selectDataFilters,
  ERROR_FILTER_OBJECT: selectDataFiltersError
}
